import React from "react";
import AdminGenericCRUDPage from "./AdminGenericCRUDPage";

const FIELDS = [
  { name: "key", label: "Anahtar (i18n key)", required: true,
    help: "ör: hero.title, footer.tagline, services.meta_ads.headline" },
  { name: "values", label: "Değerler (JSON, dil kodlarına göre)", type: "json", rows: 8,
    help: '{ "tr": "Türkçe metin", "en": "English text", "es":"…", "de":"…", "fr":"…", "ar":"…" }' },
  { name: "note", label: "Not (opsiyonel)" },
];

export default function AdminTranslationsPage() {
  return (
    <AdminGenericCRUDPage
      title="Çeviriler"
      subtitle="Site i18n metinlerini admin panelden override et — frontend bu değerleri statik JSON üstüne bindirir."
      endpoint="/admin/translations"
      identifier="key"
      fields={FIELDS}
      defaultItem={{ key: "", values: { tr: "", en: "", es: "", de: "", fr: "", ar: "" }, note: "" }}
      testIdPrefix="translations"
    />
  );
}
